import React from 'react';
import './footer.css';
import {
  FaFacebookF,
  FaTwitter,
  FaGoogle,
  FaInstagram,
  FaLinkedin,
  FaGithub,
  FaHome,
  FaEnvelope,
  FaPhone,
  FaPrint,
  FaWhatsapp,
} from 'react-icons/fa';
import logo from '../../assets/d97ae9ac8355a0d5876385dc4a41e6c7af024c07.jpg';
import { Link } from 'react-router-dom';

function WaveFooter() {
  return (
    <footer className="footer">
      <div className="waves">
        <div className="wave" id="wave1"></div>
        <div className="wave" id="wave2"></div>
        <div className="wave" id="wave3"></div>
        <div className="wave" id="wave4"></div>
      </div>

      <div className="container-fluid p-0">
        <div className="text-center text-lg-start text-white">

          <section>
            <div className="container-fluid text-center text-md-start mt-5">
              <div className="row mt-3">

                {/* Company */}
                <div className="col-md-3 col-lg-4 col-xl-3 mx-auto ">
                  <h6 className="text-uppercase fw-bold">
                    <img src={logo} width={150} height={50} />
                  </h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{
                      width: "60px",
                      backgroundColor: "#7c4dff",
                      height: "2px",
                    }}
                  />
                  <p style={{ textAlign: "justify", textIndent: "50px" }}>
                    At Electiaa, design and marketing are at the heart of our brand identity and business growth strategy.
                    We believe that effective design is more than just aesthetics — it's a strategic tool that communicates
                    our values, enhances user experience, and builds trust with our audience.
                  </p>
                </div>

                {/* Main Links */}
                <div className="col-md-2 col-lg-2 col-xl-2 mx-auto ">
                  <h6 className="text-uppercase fw-bold">Links</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{
                      width: "60px",
                      backgroundColor: "#7c4dff",
                      height: "2px",
                    }}
                  />
                  <p onClick={() => window.location.href = "/"} style={{ cursor: "pointer" }}>Home</p>
                  <p onClick={() => window.location.href = "/aboutmain"} style={{ cursor: "pointer" }}>About Us</p>
                  <p onClick={() => window.location.href = "/servicepage"} style={{ cursor: "pointer" }}>Our Services</p>
                  <p onClick={() => window.location.href = "/contact"} style={{ cursor: "pointer" }}>Why Choose Us</p>
                  <p onClick={() => window.location.href = "/socialmedia"} style={{ cursor: "pointer" }}>Social</p>
                </div>

                {/* Service Links */}
                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto ">
                  <h6 className="text-uppercase fw-bold">Links</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{
                      width: "60px",
                      backgroundColor: "#7c4dff",
                      height: "2px",
                    }}
                  />
                  <p onClick={() => window.location.href = "/web"} style={{ cursor: "pointer" }}>Web Development</p>
                  <p onClick={() => window.location.href = "/logo"} style={{ cursor: "pointer" }}>Logo Design</p>
                  <p onClick={() => window.location.href = "/Invitation"} style={{ cursor: "pointer" }}>E-Invitation</p>
                  <p onClick={() => window.location.href = "/digital"} style={{ cursor: "pointer" }}>Digital Marketing</p>
                  <p onClick={() => window.location.href = "/seo"} style={{ cursor: "pointer" }}>SEO</p>
                </div>

                {/* Contact */}
                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0">
                  <h6 className="text-uppercase fw-bold">Contact</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{
                      width: "60px",
                      backgroundColor: "#7c4dff",
                      height: "2px",
                    }}
                  />
                  <p><FaHome className="me-2" /> No:21, Vinayaga Nagar, <br></br>Okkiyam, Thoraipakkam
                    <br></br>Chennai - 600097</p>
                  <p><FaEnvelope className="me-2" /> info@eletiaa.com</p>
                  <p><FaEnvelope className="me-2" /> eletiaa.com@gmail.com</p>
                  <p><FaPhone className="me-2" /> +91 87789 34301 </p>

                </div>
              </div>
            </div>
          </section>

          {/* Copyright */}
          <div
            className="footer-bottom d-flex justify-content-between align-items-center p-3"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
          >
            <div className="text-left">
              © 2025 |
              <span
                onClick={() => window.open("https://website.electiaa.com/", "_blank")}
                style={{ cursor: "pointer" , textDecoration:"underline"}}
                className="footer-link"
              >
              Electiaa
              </span>
            </div>


            <div className="text-right">
              <a href="https://www.facebook.com/profile.php?id=61577395404506" target="_blank" rel="noopener noreferrer" className="mx-2 text-white">
                <FaFacebookF />
              </a>
              <a href="https://wa.me/918778934301" target="_blank" rel="noopener noreferrer" className="mx-2 text-white">
                <FaWhatsapp />
              </a>
              <a href="https://www.instagram.com/electiaa?igsh=MXVjNWIzMGllem9sdw==" target="_blank" className="mx-2 text-white">
                <FaInstagram />
              </a>
              <a href="http://www.linkedin.com/in/farzana-rahman-b02a74352" target="_blank" rel="noopener noreferrer" className="mx-2 text-white">
                <FaLinkedin />
              </a>
            </div>
          </div>


        </div>
      </div>
    </footer>
  );
}

export default WaveFooter;
